import PersonInvolved from './PersonInvolved';

export default PersonInvolved;
